import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import parse from 'autosuggest-highlight/parse';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const SearchPlaces = ({gmap}) => {
  const {
      value,
      suggestions: { status, data },
      setValue,
      clearSuggestions,
  } = usePlacesAutocomplete({
      googleMaps: gmap,
      callbackName: "YOUR_CALLBACK_NAME",
      requestOptions: {
      /* Define search scope here */
      },
      debounce: 300,
  });
  const [searchOptions, setSearchOptions] = React.useState([])
  const [finalVal, setFinalVal] = React.useState(null)
  const[height, setHeight] = React.useState(window.innerHeight)
  const[width, setWidth] = React.useState(window.innerWidth)

  // const ref = useOnclickOutside(() => {
  //   // When the user clicks outside of the component, we can dismiss
  //   // the searched suggestions by calling this method
  //   clearSuggestions();
  // });

  React.useEffect(() => {
      if(status === 'OK'){
          setSearchOptions(data);
      }
      if(value.length == 0 && searchOptions.length!=0){
          clearSuggestions()
          setSearchOptions([])
      }
  },[data, value, status])


  const handleSelect = (event, newValue) => {
      // When the user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(newValue.description, false);
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: newValue.description }).then((results) => {
      const { lat, lng } = getLatLng(results[0]);
      gmap.setZoom(20)
      gmap.setCenter({ lat, lng });
      });
  };

  return (
    <div style={{width:'100%'}}>
      <Autocomplete
          getOptionLabel={(option) =>
              typeof option === 'string' ? option : option.description
            }
          sx={{width: '100%', height:'50px', backgroundColor: '#ffffff'}}
          filterOptions={(x) => x}
          options={searchOptions}
          autoComplete
          includeInputInList
          filterSelectedOptions
          value={finalVal}
          noOptionsText="No locations"
          onChange={handleSelect}
          onInputChange={(event, newInputValue) => {
              setValue(newInputValue);
          }}
          renderInput={(params) => (
              <TextField {...params} label="Search Location" fullWidth />
          )}
          renderOption={(props, option) => {
              const matches =
                option.structured_formatting.main_text_matched_substrings || [];
      
              const parts = parse(
                option.structured_formatting.main_text,
                matches.map((match) => [match.offset, match.offset + match.length]),
              );
      
              return (
                <li {...props}>
                  <Grid container alignItems="center">
                    <Grid item sx={{ display: 'flex', width: 44 }}>
                      <LocationOnIcon sx={{ color: 'text.secondary' }} />
                    </Grid>
                    <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                      {parts.map((part, index) => (
                        <Box
                          key={index}
                          component="span"
                          sx={{ fontWeight: part.highlight ? 'bold' : 'regular' }}
                        >
                          {part.text}
                        </Box>
                      ))}
                      <Typography variant="body2" color="text.secondary">
                        {option?.structured_formatting?.secondary_text}
                      </Typography>
                    </Grid>
                  </Grid>
                </li>
              );
          }}
      />
    </div>
  );
};

export default SearchPlaces